import Order                                       from "../../../pages/site/Order";
import Orders                                      from "../../../pages/site/Orders";
import {getSiteOrderEditRoute, getSiteOrdersRoute} from "./factory/order";

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
    {
        path: getSiteOrdersRoute(),
        component: Orders,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getSiteOrderEditRoute(),
        component: Order,
        exact: false,
        type: 'route',
        loginRequired: true,
    },
];

export default routes;
